import { SET_REDIRECTION, SetRedirectionAction } from "./types"

export function SetRedirection(value: string): SetRedirectionAction {
  return {
    type: SET_REDIRECTION,
    payload: value,
  }
}
